export default __webpack_public_path__ + "0a3ef263c95d7227eb0fe781306ca7b2.svg";